import * as React from "react"

import { cn } from "@/lib/utils"

// Aligned with the hygenius-pria reference input
// (../hygenius-pria/src/components/ui/input.tsx). Two changes against www's
// previous version: `text-base` at small sizes replaces a flat `text-sm`, which
// also stops iOS zooming the page on focus and matches what textarea.tsx
// already did; and `file:text-foreground` colors the file-picker button label.
// The previous file also exported an empty `InputProps` interface; it had no
// importers anywhere in www and the reference has none.
//
// `min-[768px]:text-sm` rather than the reference's `md:text-sm`: the point of
// the 16px floor is that Safari zooms the page when a focused field is smaller,
// which is a fact about the device, not about the width of whatever box the
// field sits in. `md:` is a page container query here (see tailwind.config.js),
// so inside the chat panel — a third of a desktop window, well under 768px — it
// never matched and every field in the chat's forms rendered at 16px while the
// same form on /pria rendered at 14px.

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 min-[768px]:text-sm",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
